export enum PromotionEffectTargetEnum {
  Item = 'item',
  Delivery = 'delivery',
  Cart = 'cart',
}
